import React from 'react';

import type { LogBiFn } from './../../../../../_shared/bi-context-provider/bi-context-provider';

import type { GalleryItem, SelectFileFn } from '../../common-types';
import { arrayMoveImmutable } from '../utils';
import { MediaItemActionMenu } from './media-item-action-menu';
import { SortableList } from './sortable-list';

type MediaListProps = {
  galleryItems: GalleryItem[];
  onFileSelect: SelectFileFn;
  onEditClick: () => void;
  onChange: (data: { type: 'sort' | 'delete' | 'selection'; items: GalleryItem[] }) => void;
  onItemDoubleClick: (index: number) => void;
  logBi: LogBiFn;
};

export const MediaList: React.FC<MediaListProps> = ({
  onFileSelect,
  onEditClick,
  onItemDoubleClick,
  galleryItems,
  onChange,
  logBi,
}) => {
  return (
    <>
      <MediaItemActionMenu
        items={galleryItems}
        onSelectAllClick={() =>
          onChange({
            type: 'selection',
            items: galleryItems.map(item => ({ ...item, selected: true })),
          })
        }
        onUnselectAllClick={() =>
          onChange({
            type: 'selection',
            items: galleryItems.map(item => ({ ...item, selected: false })),
          })
        }
        onDeleteClick={() => {
          onChange({ type: 'delete', items: galleryItems.filter(i => !i.selected) });
        }}
        onEditClick={onEditClick}
        logBi={logBi}
      />
      <SortableList
        items={galleryItems}
        onSortEnd={({ oldIndex, newIndex }) => {
          if (oldIndex !== newIndex) {
            const sortedItems = arrayMoveImmutable(galleryItems, oldIndex, newIndex);
            onChange({ type: 'sort', items: sortedItems });
          }
        }}
        onItemClick={id => {
          onChange({
            type: 'selection',
            items: galleryItems.map((item, index) => ({
              ...item,
              selected: index === id ? !item.selected : item.selected,
            })),
          });
        }}
        onItemDoubleClick={onItemDoubleClick}
        onFileSelect={onFileSelect}
        logBi={logBi}
      />
    </>
  );
};
